/**
 * French writing rules applied to what the screen shows (QA 13/10 evening, 6th pass):
 *  - « 0,2 jours » → « 0,2 jour »: in French a quantity under 2 stays singular (« 1,5 jour », « 2 jours »);
 *  - a no-break space before ? ! : ; (« Pourquoi ? », « Chez Primeur : … »): an ordinary space becomes a no-break one,
 *    and one is added when the sign is glued to a word. Never inside « 17:45 » or a link: the sign must be followed by
 *    a space or the end of the text.
 * No lookbehind (older Safari cannot parse it): the character before is captured and written back.
 */
const NBSP = ' ';
const DAYS_UNDER_2 = /(^|[^\d.,])([01](?:[.,]\d+)?)([   ])jours\b/g;
const SPACED = /[ \t]([?!:;])(?=\s|$|»|\))/g;
const GLUED = /([A-Za-zÀ-ÖØ-öø-ÿ)»%*])([?!:;])(?=\s|$)/g;

export function frenchDaysSingular(text) {
  if (typeof text !== 'string' || !text) return text;
  return text.replace(DAYS_UNDER_2, '$1$2$3jour');
}

export function frenchPunctuation(text) {
  if (typeof text !== 'string' || !text) return text;
  return text.replace(SPACED, `${NBSP}$1`).replace(GLUED, `$1${NBSP}$2`);
}

export const isFrench = (lang) => /^fr/i.test(String(lang || ''));

/** Both rules for a French reader; any other language is returned as it is. */
export function frenchTypo(text, lang) {
  if (!isFrench(lang)) return text;
  return frenchPunctuation(frenchDaysSingular(text));
}

/**
 * i18next post-processor: every translated French text follows the two rules, whatever the number put in it
 * (« rupture dans {{d}} jours » with d = 0,5 → « rupture dans 0,5 jour »).
 */
export const frenchTypoPostProcessor = {
  type: 'postProcessor',
  name: 'frenchTypo',
  process(value, _key, options, translator) {
    const lng = (options && options.lng) || (translator && translator.language);
    return typeof value === 'string' ? frenchTypo(value, lng) : value;
  },
};
